/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartUpdateItemVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  item: Types.CartItemInput
  itemIndex: Types.Scalars['Int']
}>

export type CartUpdateItem = {
  __typename: 'Root'
  cartUpdateItem: {
    __typename: 'CartUpdateItemPayload'
    cart: { __typename: 'Cart'; id: number | null; uuid: string | null } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartUpdateItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartUpdateItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'item' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CartItemInput' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'itemIndex' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartUpdateItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'item' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'item' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemIndex' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'itemIndex' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartUpdateItemMutationFn = Apollo.MutationFunction<
  CartUpdateItem,
  CartUpdateItemVariables
>

/**
 * __useCartUpdateItem__
 *
 * To run a mutation, you first call `useCartUpdateItem` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdateItem` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdateItem, { data, loading, error }] = useCartUpdateItem({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      item: // value for 'item'
 *      itemIndex: // value for 'itemIndex'
 *   },
 * });
 */
export function useCartUpdateItem(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartUpdateItem,
    CartUpdateItemVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CartUpdateItem, CartUpdateItemVariables>(
    CartUpdateItemDocument,
    options
  )
}
export type CartUpdateItemHookResult = ReturnType<typeof useCartUpdateItem>
export type CartUpdateItemMutationResult = Apollo.MutationResult<CartUpdateItem>
export type CartUpdateItemMutationOptions = Apollo.BaseMutationOptions<
  CartUpdateItem,
  CartUpdateItemVariables
>
